import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import Loading from "../../../Loading";
import EditForm from "./components/Form";
import FormMenu from "../components/Menu";
import Header from "../components/Header";
import { noUpdate, useForm } from "../hook";
import Style from "../../../../screens/Edit/style";
import { hasNotChanged } from "../../../../screens/Edit";
import { actions } from '../../../../store/reducers/authentication';
import { AdminService, AuthenticationService } from "../../../../services";
import { NOTIFICATION_MODE, onBeforeUnload, useForms } from "../../../../context/Forms";
import { usePermissions } from "../../../../permissions/usePermissions";

const type = 'edit';

export default function SettingsEdit({ mod = 'pme' }) {
  const dispatch = useDispatch();
  const { setNotificationMode } = useForms();
  const [isChanged, setIsChanged] = useState(false);
  const [inputLoading, setInputLoading] = useState(false);
  const { activeForm, activeFormKey, form, initialData, data, setData, goToView, user } = useForm({ mod });
  const canEditOrganisation = usePermissions({ permission: 'settings.canEditOrganisation' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isChanged) {
      setNotificationMode(NOTIFICATION_MODE.PROJECT_SOURCES);
      window.addEventListener('beforeunload', onBeforeUnload);
    } else {
      setNotificationMode(NOTIFICATION_MODE.EMPTY);
      window.removeEventListener('beforeunload', onBeforeUnload);
    }
  }, [isChanged]);

  const onChange = (_data = {}) => {
    const _newData = { ...data, ..._data };

    if (!hasNotChanged(initialData, _newData)) {
      setIsChanged(true);
    } else {
      setIsChanged(false);
    }

    setData((prev) => ({ ...prev, ..._data }));
  }

  return (
    <Style>
      <Header
        type={type}
        changed={inputLoading ? false : isChanged}
        goToView={goToView}
        mod={mod}
        onSave={async () => {
          setLoading(true);
          const _data = Object.keys(data).reduce((all, key) => {
            if (!noUpdate.includes(key)) {
              all[key] = data[key];
            }

            return all;
          }, {});

          const company = { logo: data.companyLogo };

          if (mod !== 'admin') {
            company.settings = {
              systemNotifiications: data.systemNotifiications,
              activityNotifiications: data.activityNotifiications,
              walletNotifiications: data.walletNotifiications,
              textOnlyEmail: data.textOnlyEmail,
            };
          }

          try {
            await AuthenticationService.editUserSettings(_data);

            if (canEditOrganisation) {
              await AdminService.updateCompany(data.company.id, company);
            }

            setNotificationMode(NOTIFICATION_MODE.EMPTY);
            window.removeEventListener('beforeunload', onBeforeUnload);
            dispatch(actions.updateUser({
              ..._data,
              role: user.role,
              company: { ...user.company, ...company },
            }));
            goToView();
          } catch (err) {
            console.log(err);
          }
        }}
      />
      <div className="view-content">
        <FormMenu activeFormKey={activeFormKey} form={form} />
        <div className="form-edit">
          <EditForm
            activeForm={activeForm}
            onChange={onChange}
            setInputLoading={setInputLoading}
            inputLoading={inputLoading}
            data={data}
          />
        </div>
      </div>
      {loading ? <Loading /> : null}
    </Style>
  );
}
